import React from 'react'

const BannerLandingClaims = (props) => (
    <section id="banner" className="style2">
        <div className="inner">
            <header className="major">
                <h1>Claims &amp; payments</h1>
            </header>
            <div className="content">
                <h2>Methodology, calculations, and health care benefits</h2>
            </div>
        </div>
    </section>
)

export default BannerLandingClaims



// WEBPACK FOOTER //
// ./src/components/BannerLandingClaims.js